import $ from 'jquery';
import { EventEmitter } from 'events';

import * as LanguageStore from './../../stores/language-store';

export class LanguageMenu extends EventEmitter {
    constructor() {
        super();
        this.buttons = $('.language li');
        this.toggleLangBtn(LanguageStore.get());
        this.initButtons();
    }

    initButtons(){
        const that = this;
        this.buttons.click( function(event) {
            const lang = $(this).data('lang');
            that.toggleLangBtn(lang);
            LanguageStore.set(lang);
            that.emit('onChangeLanguage');
        });
    }

    toggleLangBtn(newLang) {
        this.buttons.each( function() {
            const btnLang = $(this).data('lang');
            if(btnLang !== newLang) {
                $(this).addClass('on');
            }else {
                $(this).removeClass('on');
            }
        });
    }
}
